import {Actions as SelfAuthActions} from './selfAuthConstants';

const initialState = {
    name: '',
    surname: '',
    tin: '',
    birthdate: '',
    postcode: '',
    consentEmailCommunication: '',
    verificationId: '',
    verificationChallenge: '',
    error: false,
    success: false,
    busy: false
}

export default function selfAuthReduce (state: any= initialState, action: any){
    switch(action.type){
        case SelfAuthActions.VALIDATE_PENDING:
            return {
                ...state,
                busy: true
            }
        case SelfAuthActions.VALIDATE_REJECTED:
            return {
                ...state,
                error: true
            }
        case SelfAuthActions.VALIDATE_FULLFILLED:
            return {
                ...state,
                busy: false,
                success: true
            }
        default:
            return state
    }

}